<template>
<div>
  
  <br> <h2>本系统仅供Freebeat公司内部使用，如果您是公司相关人员，请登录后查看</h2><br>
  <div class="login-container">
    
  
    <el-form ref="loginForm" :model="loginData" class="login-form" label-width="80px">
      <el-form-item label="邮箱" prop="username">
        <el-input v-model="loginData.username" placeholder="请输入用户名/邮箱"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input type="password" v-model="loginData.password" placeholder="请输入密码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="login">登录</el-button>
      </el-form-item>
    </el-form>
  </div></div>
</template>  

<script>

export default {
  data() {
    return {
      loginData: {
        username: '',
        password: ''
      }
    };
  },
  methods: {
    login() {
      this.$refs.loginForm.validate(valid => {

        if (valid) {
          const loginData = {
            username: this.loginData.username,
            password: this.loginData.password
          };

          this.$http.post('/da/login', loginData) // 请将 'port' 替换为实际的端口号
            .then(response => {
              const token = response.data.access_token;
              // 在这里保存 token，可以使用 Vuex 或 localStorage 等方法进行保存
              localStorage.setItem('token', token);
              // 登录成功后的逻辑，例如跳转到其他页面
              // 获取之前被拦截跳转的路由信息
              const redirect = this.$route.query.redirect || '/';

              // 使用 router.replace() 跳转到登录前的页面
              this.$router.replace(redirect);
            })
            .catch(error => {
              // 处理登录错误
            });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped>
.login-container {
  max-width: 430px;
  margin: 0 auto;
  padding: 20px;
}

.login-form {
  margin-top: 20px;
}
</style>